//main model
export class Organization {
    organisationId: string;
    name: string;
    sfdcCustomerNumber: string;
    instanceLimit: number;
    logoProfileImageId: string;
    logoProfileImage: ProfileImage;
    profileContractId: string;
    profileContact: profileContactModel;
    profileContract: profileContractModel;
    file: any;
    licenseLimitICE: number;
    licenseLimitiDMS: number;
    isFedrated: boolean = false;
    logo: string;
    azureADIssuerUrl: string;
    azureADInstance: string;
    azureADDomain: string;
    azureADTenantId: string;
    azureADClientId: string;
    azureADClientSecret: string;
    azureADB2CExtensionAppClientId: string;
    azureADCallbackPath: string;
}

//sub model
export class profileContactModel {
    profileContactId: string;
    addressId: string;
    firstName: string;
    lastName: string;
    jobTitle: string;
    address: organizationAddress;
    telephone: string;
    email: string;
    fullName?: string;
}

//sub model
export class organizationAddress {
    addressId: string;
    line1: string;
    line2: string;
    city: string;
    state: string;
    country: string;
    zipcode: string;
}

//sub model
export class profileContractModel {
    profileContractId: string;
    name: string;
    description: string;
    startDate: string;
    endDate: string;
    profileContact: profileContactModel;
}

//sub model
export class SecurityLevels {
    securityLevelId: string;
    level: number;
    name: string;
}

export class OrganizationDisplay {
    organizationId: string;
    organizationName: string;
    logoProfileImage: string;
}

export class ProfileImage {
    profileImageId: string;
}

export class Dropdown {
    firstName: string;
    lastName: string;
    email: string;
}

export class OrganizationIds {
    organisationId: string;
    profileContractId: string;
    profileContactId: string;
    addressId: string;
}

//InstanceUser
export class InstanceUser {
    instanceId: any;
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    securityRole: string;
    isDerivedFromTemplate?: boolean;
    active: boolean;
}

export class UserInstanceModel {
    userInstanceId?: any;
    instanceId: any;
    userId: string;
    active: boolean;
}

export class OrgnaizationForDashboard {
    logo: string;
    organisationId: string;
    organisationName: string;
    instanceCountiDMS: string;
    instanceCountICE: string;
    userCount: string;
}
